export const successApiStatusCodes: number[] = [
	0
];

export const successRequestStatusCodes: number[] = [
	200,
	201,
	202,
	203,
	204
];

export const skipApiStatusCodes: number[] = [];

export const autoLogoutApiStatusCodes: number[] = [
	// 304028,
	// 305026,
	// 305027,
	300007,
	// 305035,
	// 305031,
	// 304029,
	// 304031,
	// 304032,
	// 304033,
	// 304034,
	// 304035,
	300013,
	300010
];

export const refreshTokenApiStatusCodes: number[] = [
	401
];